export const comments_3324448 = {"data":{"data":[],"links":{}}}